import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import PhoneIcon from '../../../globals/images/icon-phone.svg'
import EmailIcon from '../../../globals/images/icon-blue-email.svg'
import { LoadingButton as Button } from '../LoadingButton/LoadingButton' 
import Container from '../../shared/container/Container'
import { MFA } from '../MFASteps'
import FactorOption from '../../shared/factorOption/FactorOption'
import { MFADomain } from '../../domain/mfa.services'
import { trackEventMessage } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_LOGIN_SEND_CODE, MFA_SETUP_EMAIL, MFA_SETUP_SMS } from '../../../constants'

export const StepVerification = ( { onClose, onSendCode, debounce,  onSetUpClick, phoneNumber, emailAddress, factors, webId, userId } ) => {

    const headerReference = useRef( null )
  
const onHandleClick = ( factorValue ) => {
    const factorMsg = factorValue == MFA.FACTORS.EMAIL ? MFA_LOGIN_SEND_CODE.SEND_CODE_EMAIL : MFA_LOGIN_SEND_CODE.SEND_CODE_SMS
    trackEventMessage( new EventModel( factorMsg, webId ) )
    const factorObj = factors.find( f => f.factorType == ( factorValue == MFA.FACTORS.EMAIL ? MFA.factorType.email : MFA.factorType.sms ) )
    if( !factorObj ) return null
    onSendCode( factorObj.id, factorValue )
}

const onHandleSetUpClick = ( factorValue ) => {
    const factorMsg = factorValue == MFA.FACTORS.EMAIL ? MFA_SETUP_EMAIL.SEND_CODE : MFA_SETUP_SMS.SEND_CODE
    trackEventMessage( new EventModel( factorMsg, webId ) )
    onSetUpClick( factorValue )
}

const onHandleClose = ( ) => {
    trackEventMessage( new EventModel( MFA_LOGIN_SEND_CODE.CLOSE, webId ) )
    onClose( )
}

const renderSmsFactorOption = () => { 
    const activeSms = MFADomain.IsFactorActive( factors, MFA.factorType.sms )
    const activeEmail = MFADomain.IsFactorActive( factors, MFA.factorType.email )

    if( !activeSms ) return <></>

    return <>
        <FactorOption img={ PhoneIcon } title= { MFA.StepVerification.textTitleSMS } onSetUpClick= { () => { onHandleSetUpClick( MFA.FACTORS.SMS ) } } />
        <div className='mb-9 c-mfa-label--content--phone-number-verification'>
            <div className='mr-1'><label tabIndex='0' data-testid="lbl-smsEnrollment-text" className='c-mfa-label--content' aria-label={ MFA.StepVerification.text }>{ `${ MFA.StepVerification.text }` }</label>&nbsp;<label tabIndex='0' className='c-mfa-label--content c-mfa-phone-number' aria-label={ phoneNumber } data-testid="lbl-phoneNumber" >{ phoneNumber }</label></div>
        </div>
        <div>
            <Button debounce={ debounce } id='dt-mfa-requestcode-send-sms-code' tabIndex={ 0 } className={ 'c-btn c-btn--tertiary mb-5' } onClick = { () => { onHandleClick( MFA.FACTORS.SMS )  } } aria-label={ MFA.StepVerification.buttonTextSMS + 'Enabled' } name="setupButton" type='button' data-testid="btn-issue-sms">{ MFA.StepVerification.buttonTextSMS }</Button>
        </div>
        { activeEmail && <hr /> }
    </>
  }

const renderEmailFactorOption = () => { 
    const activeEmail = MFADomain.IsFactorActive( factors, MFA.factorType.email )

    if( !activeEmail ) return <></>
    
    return <>
        <FactorOption img={ EmailIcon } title= { MFA.StepVerification.textTitleEmail } onSetUpClick= { () => { onHandleSetUpClick( MFA.FACTORS.EMAIL ) } } />
        <div className='mb-9 c-mfa-label--content--phone-number-verification'>
            <div className='mr-1'><label tabIndex='0'  data-testid="lbl-emailEnrollment-text" className='c-mfa-label--content' aria-label={ MFA.StepVerification.text }>{ `${ MFA.StepVerification.text }` }</label>&nbsp;<label tabIndex='0' data-testid="lbl-emailAddress" className='c-mfa-label--content c-mfa-phone-number' aria-label={ emailAddress }>{ emailAddress }</label></div>
        </div>
        <div>
            <Button id='dt-mfa-requestcode-send-email-code' className={ 'c-btn c-btn--tertiary mb-5' } tabIndex={ 0 } onClick = { () => { onHandleClick( MFA.FACTORS.EMAIL ) } } aria-label={ MFA.StepVerification.buttonTextEmail + 'Enabled' } name="setupButton" type='button' data-testid="btn-issue-email">{ MFA.StepVerification.buttonTextEmail }</Button>
        </div>
    </>
  }
    
  useEffect( () => {
          headerReference?.current?.focus() 
  }, [] 
  )

return ( <>
    <Container onClose={ onHandleClose } onCloseButtonId='dt-mfa-requestcode-close'>               
        <div className='mb-9'><header ref={ headerReference } tabIndex='0' className='c-mfa-label--title' aria-label={ MFA.StepVerification.title }>{ MFA.StepVerification.title }</header></div>      
        <>
            { renderSmsFactorOption() }
            { renderEmailFactorOption() }
        </>
    </Container>
</>
)
}

StepVerification.propTypes = {
    onSendCode: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onSetUpClick: PropTypes.func.isRequired,
    phoneNumber: PropTypes.string,
    emailAddress: PropTypes.string,
    factors: PropTypes.array,
    webId: PropTypes.string,
    userId: PropTypes.string,
    debounce: PropTypes.bool
}